import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { AnimatedRoutes } from "@/components/layout/AnimatedRoutes";
import { BreadcrumbSchema } from "@/components/seo/BreadcrumbSchema";
import { Toaster } from "@/components/ui/toaster";
import { CookieConsent } from "@/components/CookieConsent";
import { MobileCallBar } from "@/components/MobileCallBar";
import { LocalBusinessSchema } from "@/components/seo/LocalBusinessSchema";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <LocalBusinessSchema />
          <ScrollToTop />
          <BreadcrumbSchema />
          <AnimatedRoutes />
          <CookieConsent />
          <MobileCallBar />

        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;